import { Link } from 'react-router-dom';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticleById } from '@/mocks/articles';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': item.href ? `https://1024.community${item.href}` : 'https://1024.community',
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500 mb-6">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            )}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}

export function buildHomeBreadcrumb(): BreadcrumbItem[] {
  return [{ label: '首页', href: '/' }];
}

export function buildCategoryBreadcrumb(slug: string): BreadcrumbItem[] {
  const cat = getCategoryBySlug(slug);
  return [
    { label: '首页', href: '/' },
    { label: cat?.name || '分类' },
  ];
}

export function buildArticleBreadcrumb(articleId: string): BreadcrumbItem[] {
  const article = getArticleById(articleId);
  const cat = article ? getCategoryBySlug(article.category) : undefined;
  const items: BreadcrumbItem[] = [{ label: '首页', href: '/' }];
  if (cat) {
    items.push({ label: cat.name, href: `/category/${cat.slug}` });
  }
  items.push({ label: article?.title || '文章' });
  return items;
}